<template>
  <div class="page-wrap DeviceList-page" ref="container">
		<Search :label="searchLabel" :dateFilter="true" @search="search" ref="search"></Search>
		<List title="结算列表" :refresh="true" :label="label" apiName="petSettlementList" @itemClick="itemClick" ref="list"></List>
  </div>
</template>
<script>
import Search from "@components/Search";
import List from "@components/List";

export default {
  name: "PetAdminFinanceList",
  components: {
		Search,
		List,
  },
  props: {},
  data: function() {
    return {
      filter: {
      },
			searchLabel : [],
			label : [
				{field : 'dateRange', title : '结算周期'},
				{field : 'cTypeStr', title : '收益类型'},
				{field : 'allStatusStr', title : '状态'},
				{field : 'price', title : '', type : "num"},
				{field : 'createTime', title : '', type : "date"},
			],
      list: [],
    };
  },
  watch: {
    $route(n) {
      if (n.name === 'PetAdminFinanceList') {
    		let prevPage = this.$prevRoute();
    		if (prevPage && prevPage.name == "PetAdmin") {
    			this.$refs.search.reSet();
    			this.filter = {};
    			this.search(this.filter);
    		}
      }
    }
  },
  mounted: function() {
  },
  computed: {},
  methods: {
		search(filter) {
			this.filter = filter;
			this.$refs.list.reload(filter);
		},
		itemClick(item) {
			this.$router.push({ path: "/petAdmin/financeDetail/" + item.id });
		}
  }
};
</script>
<style lang="scss">
body {background: #F9F9F9 !important;}
.page-wrap {
	padding: 0.3rem;
}
</style>
